<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="IPsecGW情報"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <div>
            <v-container>
              <v-row v-if="ipsecGW.suffix === null">
                <v-col class="text-right">
                  <v-btn
                    color="primary"
                    @click="registerSuffix"
                    v-permission.config
                    >サフィックス登録</v-btn
                  >
                </v-col>
              </v-row>
              <!--回線番号-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="IPsecGW回線番号"
                    :value="ipsecGW.enumber"
                  />
                </v-col>
              </v-row>

              <!--回線数-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="IPsec回線数/IPsec回線接続上限数"
                    :value="
                      ipsecGW.numberOfIpsec +
                      '/' +
                      ipsecGW.upperLimitIpsec +
                      '回線'
                    "
                  />
                </v-col>
              </v-row>

              <!--サフィックス-->
              <v-row v-if="ipsecGW.suffix !== null">
                <v-col cols="12">
                  <app-label-group
                    label="サフィックス"
                    :value="ipsecGW.suffix"
                  />
                </v-col>
              </v-row>

              <!--WANアドレス-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="WANアドレス"
                    :value="ipsecGW.wanAddress"
                  />
                </v-col>
              </v-row>

              <!--IPsecGWアドレス-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="IPsecGWアドレス"
                    :value="ipsecGW.ipsecGatewayAddress"
                  />
                </v-col>
              </v-row>

              <!--管理用アドレス①-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="管理用アドレス①"
                    :value="ipsecGW.manageAddress1"
                  />
                </v-col>
              </v-row>

              <!--管理用アドレス②-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="管理用アドレス②"
                    :value="ipsecGW.manageAddress2"
                  />
                </v-col>
              </v-row>

              <!--管理用アドレス③-->
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="管理用アドレス③"
                    :value="ipsecGW.manageAddress3"
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type { VisibleIpSecGW } from "@/views/nwSetting/ipSecGw/IpSecGWList.vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import IpSecGWModify from "@/modals/ipSecGw/IpSecGWModify.vue";

export default defineComponent({
  name: "IpSecGWReference",
  props: {
    /** IPsecGW */
    ipsecGW: {
      type: Object as PropType<VisibleIpSecGW>,
      required: true,
    },
    /** IPsecGW排他情報 */
    keyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  methods: {
    /** サフィックス登録 */
    async registerSuffix() {
      await this.$modal.show(IpSecGWModify, {
        ipsecGW: this.ipsecGW,
        keyId: this.keyId,
      });
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },
  },
});
</script>
